
import { Component } from 'react'
import './index.css'
import echarts from 'echarts'
import { WithTranslationProps, withTranslation } from 'react-i18next';
import icon_reportDetail_head from "../../images/icon_reportDetail_head.png"

interface Point2d {
    x: number
    y: number
}

class Point2d {
    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    translate(x: number, y: number) {
        this.x += x;
        this.y += y;
        return this;
    }
}

interface StateProps {
    data: any
}

class StableAnaly extends Component<StateProps & WithTranslationProps> {

    createLineChartFrontBack = (data: any, lineDom) => {
        // const lineDom: any = document.getElementById('lineChart')

        let xAxisData: any[] = [];
        let left = data.left || {};
        let right = data.right || {};

        for (let i = 0; i < data.cop.x.length; i++) {
            xAxisData.push(i)
        }

        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }
        if (lineDom !== null) {
            let myChart = echarts.init(lineDom)
            const option: any = {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: '8px',
                    right: '0px',
                    bottom: '6px',
                    left: '40px',
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    boundaryGap: false,
                    axisLabel: {
                        show: false,
                        inside: false,
                        fontWeight: 'bolder',
                    },
                    axisTick: {//坐标轴刻度相关设置。
                        show: false,
                    },
                    splitLine: { //坐标轴在 grid 区域中的分隔线。
                        show: true,
                        lineStyle: {
                            color: ['#D4D7E6', '#D4D7E6']
                        }
                    },
                    axisLine: { // 是否显示坐标轴轴线。
                        show: false,
                    },
                },
                yAxis: {
                    type: 'value',
                    splitArea: {
                        show: true,
                        interval: 12,
                        areaStyle: {
                            color: ['#EDEFF8', '#FFFFFF']
                        }
                    },
                    axisTick: { // 是否显示坐标轴刻度。
                        show: false
                    },
                    axisLabel: { // 是否显示刻度标签。
                        show: true,
                        color: '#2A3B76'
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#D4D7E6'
                        }
                    },
                },
                series: [
                    {
                        name: i18n.t('body'),
                        data: data.cop.y,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#0076FF'
                        }
                    },
                    {
                        name: i18n.t('leftFoot'),
                        data: left.cop.y,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#00D6B2'
                        }
                    },
                    {
                        name: i18n.t('rightFoot'),
                        data: right.cop.y,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#FF9678'
                        }
                    }
                ]
            }
            myChart.setOption(option)
        }
    }

    createLineChartLeftRight = (data: any, lineDom) => {
        // const lineDom: any = document.getElementById('lineChart')

        let xAxisData: any[] = []
        let left = data.left || {};
        let right = data.right || {};

        for (let i = 0; i < data.cop.x.length; i++) {
            xAxisData.push(i)
        }

        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }

        if (lineDom !== null) {
            let myChart = echarts.init(lineDom)
            const option: any = {
                tooltip: {
                    trigger: 'axis',
                },
                grid: {
                    top: '8px',
                    right: '0px',
                    bottom: '6px',
                    left: '40px',
                },
                xAxis: {
                    type: 'category',
                    data: xAxisData,
                    boundaryGap: false,
                    nameGap: 10,
                    axisLabel: {
                        show: false,
                        inside: false,
                        fontWeight: 'bolder',
                    },
                    axisTick: {//坐标轴刻度相关设置。
                        show: false,
                    },
                    splitLine: { //坐标轴在 grid 区域中的分隔线。
                        show: true,
                        lineStyle: {
                            color: ['#D4D7E6', '#D4D7E6']
                        }
                    },
                    axisLine: { // 是否显示坐标轴轴线。
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: ['#EDEFF8', '#FFFFFF']
                        }
                    },
                    axisTick: { // 是否显示坐标轴刻度。
                        show: false
                    },
                    axisLabel: { // 是否显示刻度标签。
                        show: true,
                        color: '#2A3B76'
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#D4D7E6'
                        }
                    }
                },
                series: [
                    {
                        name: i18n.t('body'),
                        data: data.cop.x,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#0076FF'
                        }
                    },
                    {
                        name: i18n.t('leftFoot'),
                        data: left.cop.x,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#00D6B2'
                        }
                    },
                    {
                        name: i18n.t('rightFoot'),
                        data: right.cop.x,
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        itemStyle: {
                            color: '#FF9678'
                        }
                    }
                ]
            }
            myChart.setOption(option)
        }
    }

    initEllipse = false;
    createCanvas = (data: any, ellipse) => {
        if (this.initEllipse) return;
        // let ellipse: any = document.getElementById('ellipse')
        let ctx = ellipse.getContext('2d')
        // let dpr = window.devicePixelRatio
        // ellipse.width = dpr * ellipse.getBoundingClientRect().width
        // ellipse.height = dpr * ellipse.getBoundingClientRect().height
        // ctx.scale(dpr, dpr)

        let canvasWidth = ellipse.getBoundingClientRect().width
        let canvasHeight = ellipse.getBoundingClientRect().height
        this.drawRound(ctx, canvasWidth, canvasHeight)
        this.drawLine(ctx, 0, canvasHeight / 2, canvasWidth, canvasHeight / 2)
        this.drawLine(ctx, canvasWidth / 2, 0, canvasWidth / 2, canvasHeight)

        let centerCanvas = new Point2d(canvasWidth * 0.5, canvasHeight * 0.5)
        let bodyOrigin = new Point2d(data.cop.centroidX, data.cop.centroidY)
        let bodyPoints = this.zip(data.cop.x || [], data.cop.y || []).map((point: any) => this.transformCop(bodyOrigin, point))


        let points = bodyPoints.concat(bodyOrigin)

        let [centerPoints, length] = this.fitRect(points)

        let translation = {
            x: -centerPoints.x,
            y: -centerPoints.y
        }

        let margin = {
            top: 10,
            left: 10
        }

        let factor = {
            x: (canvasWidth - 2 * margin.left) / length,
            y: (canvasHeight - 2 * margin.top) / length
        }

        bodyPoints = bodyPoints.map((point: any) => point.translate(translation.x, translation.y))

        let ellipseCenter = this.translateEllipse(data.cop.ellipse.centerX, data.cop.ellipse.centerY, translation, bodyOrigin)

        this.ellipse(ctx, centerCanvas, data.cop, ellipseCenter, factor, '#0076FF', canvasWidth, canvasHeight)
        this.ellipseCenter(ctx, centerCanvas, canvasWidth, ellipseCenter, factor)

        this.initEllipse = true;
    }

    zip(x: any, y: any) {
        return x.map((v: any, i: any) => new Point2d(v, y[i]));
    }

    // 把相对于origin的point转换到origin所在坐标系下的坐标
    transformCop(origin: any, point: any) {
        let x = origin.x + point.x;
        let y = origin.y - point.y;
        return new Point2d(x, y);
    }


    fitRect(points: any) {
        let x = points.map((point: any) => point.x);
        let y = points.map((point: any) => point.y);

        let xMin = Math.min(...x);
        let xMax = Math.max(...x);
        let yMin = Math.min(...y);
        let yMax = Math.max(...y);

        let center: any = new Point2d((xMin + xMax) / 2, (yMin + yMax) / 2);
        let length: any = Math.max(Math.abs(xMax - xMin), Math.abs(yMax - yMin));

        return [center, length];
    }

    translateEllipse(ellipseCenterX: number, ellipseCenterY: number, translation: any, openOrgin: any) {
        let ellipseCenter = new Point2d(ellipseCenterX, ellipseCenterY);
        ellipseCenter = this.transformEllipse(openOrgin, ellipseCenter);
        ellipseCenter.translate(translation.x, translation.y)
        return ellipseCenter
    }

    transformEllipse(origin: any, point: any) {
        let x = origin.x + point.x;
        let y = origin.y + point.y;
        return new Point2d(x, y);
    }

    drawRound(ctx: any, width: number, height: number) {
        ctx.beginPath()
        ctx.lineWidth = 1.5
        ctx.strokeStyle = '#2A3B76'
        ctx.arc(width / 2, height / 2, 0.45 * width, 0, Math.PI * 2, false)
        ctx.stroke()
        ctx.closePath()
    }

    drawLine(ctx: any, x1: number, y1: number, x2: number, y2: number) {
        ctx.beginPath()
        ctx.moveTo(x1, y1)
        ctx.lineTo(x2, y2)
        ctx.stroke()
        ctx.closePath()
    }

    // 椭圆
    ellipse(ctx: any, center: any, cop: any, point: any, factor: any, ctxStrokeStyle: string, canvasWidth: number, canvasHeight: number) {
        ctx.save()
        ctx.translate(center.x, center.y)
        ctx.strokeStyle = ctxStrokeStyle
        ctx.lineWidth = 1.5
        let x = point.x * factor.x
        let y = point.y * factor.y
        let major = cop.ellipse.radiusX * factor.x
        let minor = cop.ellipse.radiusY * factor.y
        ctx.beginPath()
        ctx.ellipse(x, y, major / 2, minor / 2, cop.ellipse.rotate, 0, 2 * Math.PI)
        ctx.stroke()
        ctx.restore()
    }


    // 椭圆心
    ellipseCenter(ctx: any, center: any, width: number, point: any, factor: any) {
        ctx.save()
        ctx.translate(center.x, center.y)
        let x = point.x * factor.x
        let y = point.y * factor.y
        ctx.beginPath()
        ctx.lineWidth = 1
        ctx.strokeStyle = '#2A3B76'
        ctx.arc(x, y, 0.03 * width, 0, Math.PI * 2, false)
        ctx.fill()
        ctx.closePath()
    }

    render() {

        let data = this.props.data;
        const i18n = this.props.i18n;
        if (!i18n) {
            return null;
        }
        return (
            <div className="standing-stableAnaly">
                <p className='reportCom-container-title'>
                    {/* <img src={icon_reportDetail_head} alt="icon head" /> */}
                    <span>{i18n.t('stableAnaly')}</span>
                </p>
                <ul className="flexCenter">
                    <li>
                        <p>{i18n.t('coreExcursion')}</p>
                        <p className="value">{data.cop.ellipse.area}mm²</p>
                        <p className="des">
                            {i18n.t('coreExcursionExplain1')}<br />
                            {i18n.t('coreExcursionExplain2')}
                        </p>
                        <p className='exp'>{i18n.t('coreAreaMinAnaly')}</p>
                        <canvas
                            width="162" height="162"
                            ref={(ref) => this.createCanvas(data, ref)}
                        ></canvas>
                    </li>
                    <li className="border"></li>
                    <li>
                        <div>
                            <p>{i18n.t('frontAndBackSwing')}</p>
                            <div className="chartBox">
                                <span>{i18n.t('frontSwing')}</span>
                                <span>{i18n.t('backSwing')}</span>
                                <div
                                    className="chart-core"
                                    ref={(ref) => this.createLineChartFrontBack(data, ref)}
                                ></div>
                            </div>
                        </div>
                        <div>
                            <p>{i18n.t('leftAndRightSwing')}</p>
                            <div className="chartBox">
                                <span>{i18n.t('rightSwing')}</span>
                                <span>{i18n.t('leftSwing')}</span>
                                <div
                                    className="chart-core"
                                    ref={(ref) => this.createLineChartLeftRight(data, ref)}
                                ></div>
                            </div>
                            <div className="chart-label">
                                <p><span></span>{i18n.t('leftFootCopLine')}</p>
                                <p><span></span>{i18n.t('rightFootCopLine')}</p>
                                <p><span></span>{i18n.t('bodyCopLine')}</p>
                            </div>
                        </div>

                    </li>
                </ul>
                <p className='copExp'>{i18n.t("copExplain")}</p>
            </div>
        );
    }
}

export default withTranslation()(StableAnaly)